import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SearchGraph from '@/components/Graphs/SearchGraph.vue';
import RightPane from '@/components/Search/RightPane.vue';
import AppSkeleton from '@/components/Skeleton/AppSkeleton.vue';
import { SearchResponse } from '@/models/Search';
import { computed, ComputedRef, watch } from 'vue';
import { onBeforeRouteUpdate, useRoute } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();

const query = computed(() => route.query.q as string);
const entities: ComputedRef<SearchResponse[]> = computed(() => store.getters['search/entities']);

store.dispatch('loading/setLoading');
store.dispatch('search/fetch', { query: query.value }).then(() => {
  store.dispatch('loading/unsetLoading');
});

onBeforeRouteUpdate((to) => {
  store.dispatch('search/fetch', { query: to.query.q as string });
});

/**
 * Sets loading state for entitiy fetching.
 * Works, but could be refactored to trigger loading where entities are acutally fetched
 */
watch([entities], ([newEntities]) => {
  if (newEntities.length === 0) {
    store.dispatch('loading/setLoading');
  } else {
    store.dispatch('loading/unsetLoading');
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppSkeleton, null, {
    main: _withCtx(() => [
      _createVNode(SearchGraph, { entities: _unref(entities) }, null, 8, ["entities"])
    ]),
    right: _withCtx(() => [
      _createVNode(RightPane, { entities: _unref(entities) }, null, 8, ["entities"])
    ]),
    _: 1
  }))
}
}

})